import { render, staticRenderFns } from "./NotificationBadge.vue?vue&type=template&id=33dd8245&scoped=true&"
import script from "./NotificationBadge.vue?vue&type=script&lang=ts&"
export * from "./NotificationBadge.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationBadge.vue?vue&type=style&index=0&id=33dd8245&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dd8245",
  null
  
)

export default component.exports